module.exports = __webpack_public_path__ + "img/box.ecd0db22.png";